import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import autoFillLights from 'rangeConfig/pax/behaviors/autoFillLights';
import autoFillLightsDrop from 'rangeConfig/pax/behaviors/autoFillLightsDrop';
import platform from 'rangeConfig/shared/utils/platform';
import removeInnerLightsFromScene from 'rangeConfig/pax/behaviors/removeInnerLightsFromScene';
import removeOuterLightsFromScene from 'rangeConfig/pax/behaviors/removeOuterLightsFromScene';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';
import withInlineMessage from 'rangeConfig/shared/widgets/withInlineMessage';
import CategoryAdditionalInlineMessage from 'components/ProductSidebar/CategoryWidget/CategoryAdditionalInlineMessage';
import { matchLightsToFramesInScene } from 'rangeConfig/pax/filters/mainMenuProductFilters';

const categories = {
  desktop: [
    {
      id: 'outerLight',
      categoryTitle: 'storageone.productListOuterLights',
      products: [{ path: 'type', value: ProductType.PAX_OUTER_LIGHT }],
      noneOption: {
        title: 'storageone.productListNoOuterLightsOptionTitle',
        subtitle: 'storageone.productListNoOuterLightsOptionSubtitle',
        behaviors: { removeProducts: [removeOuterLightsFromScene] },
        selected: noProductsWithTypesInScene([ProductType.PAX_OUTER_LIGHT])
      }
    },
    {
      id: 'innerLight',
      categoryTitle: 'storageone.productListInnerLights',
      products: [
        { path: 'type', value: ProductType.PAX_INNER_LIGHT },
        { path: 'type', value: ProductType.PAX_INNER_LIGHT_OVERSIDAN }
      ],
      cluster: ['type', 'design'],
      noneOption: {
        title: 'storageone.productListNoInnerLightsOptionTitle',
        subtitle: 'storageone.productListNoInnerLightsOptionSubtitle',
        behaviors: { removeProducts: [removeInnerLightsFromScene] },
        selected: noProductsWithTypesInScene([
          ProductType.PAX_INNER_LIGHT,
          ProductType.PAX_INNER_LIGHT_OVERSIDAN
        ])
      }
    }
  ],
  mobile: [
    {
      id: 'outerLight',
      categoryTitle: 'storageone.productListOuterLights',
      products: [{ path: 'type', value: ProductType.PAX_OUTER_LIGHT }],
      widgets: [
        {
          component: withInlineMessage(
            'storageone.lightsDriversAdditionalInfo',
            true
          )(CategoryAdditionalInlineMessage)
        }
      ],
      noneOption: {
        title: 'storageone.productListNoOuterLightsOptionTitle',
        subtitle: 'storageone.productListNoOuterLightsOptionSubtitle',
        behaviors: { removeProducts: [removeOuterLightsFromScene] },
        selected: noProductsWithTypesInScene([ProductType.PAX_OUTER_LIGHT])
      }
    },
    {
      id: 'innerLight',
      categoryTitle: 'storageone.productListInnerLights',
      products: [
        { path: 'type', value: ProductType.PAX_INNER_LIGHT },
        { path: 'type', value: ProductType.PAX_INNER_LIGHT_OVERSIDAN }
      ],
      widgets: [
        {
          component: withInlineMessage(
            'storageone.lightsDriversAdditionalInfo',
            true
          )(CategoryAdditionalInlineMessage)
        }
      ],
      cluster: ['type', 'design'],
      noneOption: {
        title: 'storageone.productListNoInnerLightsOptionTitle',
        subtitle: 'storageone.productListNoInnerLightsOptionSubtitle',
        behaviors: { removeProducts: [removeInnerLightsFromScene] },
        selected: noProductsWithTypesInScene([
          ProductType.PAX_INNER_LIGHT,
          ProductType.PAX_INNER_LIGHT_OVERSIDAN
        ])
      }
    }
  ]
};

const lightsProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  infoButtonAriaLabel: 'name typeName',
  behaviors: {
    productClicked: [autoFillLights],
    productDropped: [autoFillLightsDrop]
  },
  productFilters: [matchLightsToFramesInScene],
  sortOrder: [],
  cluster: ['type', 'name', 'typeName', 'design'],
  categories: categories[platform]
};

export default lightsProductListConfig;
